<div class="side-padding sm:px-0">
  <div class="flex flex-col gap-4">
    <div class="p-5 pb-0 bg-white rounded-10 max-sm:p-3 max-sm:pb-0">
      <h1
        class="mb-5 cursor-pointer font-roboto-500 text-18 max-sm:text-14 text-blue"
      >
        {{ "Partidos recientes" }}
      </h1>
    </div>

    <app-no-result message="No hay partidos disponibles en este momento" />
  </div>
</div>
